import React from 'react';
import { useTranslation } from 'react-i18next';

const OptionBytesView: React.FC = () => {
  const { t } = useTranslation('webflash');

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
        {t('readback.optionBytes')}
      </h3>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-gray-500 dark:text-gray-400 border-b dark:border-gray-700">
            <th className="pb-2">Field</th>
            <th className="pb-2">Value</th>
          </tr>
        </thead>
        <tbody className="text-gray-400">
          <tr>
            <td className="py-1">{t('target.rdpLevel')}</td>
            <td className="py-1 font-mono">--</td>
          </tr>
          <tr>
            <td className="py-1">Raw</td>
            <td className="py-1 font-mono">--</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OptionBytesView;
